import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Location, DatePipe } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { CommonEnums } from 'src/app/utils/enum-utils';
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { Otp, MyAccountDto, MyaccountMobileOrEmailDto } from 'src/app/model/qModel.model';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';

declare let $: any;
@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styles: [
  ]
})
export class AddUserComponent implements OnInit {
  getEmailValue: string;
  verifyEmail: boolean;
  verifyMobileNumber: boolean;
  myaccountDto: MyAccountDto = new MyAccountDto();
  isSubmitted: boolean;
  isOtpVerification: boolean;
  enableMobileVerificationIcon: boolean;
  mobileInput: boolean;
  emailOrMobileVerificationDto: MyaccountMobileOrEmailDto = new MyaccountMobileOrEmailDto();
  submitOTPDto: Otp = new Otp();
  isEmailOTPSent: boolean = false;
  isSentOTP: boolean = false;
  forgotPasswordErrorMessage: string = "";
  timer: any;
  timeOver: boolean = true;
  emailResponseOTP: any;
  emailErrorMessage: any;
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  durationMinutes: any;
  isVerified: boolean = false;
  isEmailVerified: boolean = false;
  otpValue: any;
  loggedInUser: any;
  screenWidth: any;
  screenHeight: any;
  selectedLanguage: any;
  language: string | null;
  modalForEng: boolean;
  addUserErrorMessage: any = null;
  showAddUserPopup: string;
  emailSentUserName: any;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  SearchCountryField = SearchCountryField;
  isLoading: boolean = false;
  mobileOrEmailOTP: String;
  emailValue: string = ''; // Bound to the input field
  storedEmail: string = ''; // To store the previously validated email
  editButon: boolean;
  initialName: string;
  intialPhoneNumber: number;
  dialCodeNotInd: number;
  isHierarchy: boolean = false;
  @Input() isupdateUser: boolean = false;
  @Input() isupdateProfile: boolean = false;
  @Input() updateUser: any;
  @Input() assignedUserStatus: any;
  @Output() removeChildEvent = new EventEmitter<void>();

  private _commonservice: any;
  myAccountData: any;
  initialPhoneNumber: any;
  selectedCountryCode: number;
  selectedCountryISO: CountryISO = CountryISO.India; // Default to India or any country
  currentFlagUrl: string = '';
  constructor(private _formBuilder: FormBuilder, private _service: ApiService, private _toastr: ToastrService, private _translate: TranslateService, private _router: Router, private location: Location, private datePipe: DatePipe) { }

  addUserForm: FormGroup = new FormGroup({
    name: new FormControl(''),
    role: new FormControl(''),
    email: new FormControl(''),
    gender: new FormControl(''),
    phone: new FormControl(''),
    dob: new FormControl(''),
  });
  keyPressAlphaNumericWithCharacters(event: any, name: any) {
    if (name == 'email') {
      if (this.addUserForm.controls['role'].value == this.CommonEnum.CHILD) {
        this.isEmailVerified = false;
      }

      if (event.target.selectionStart === 0) {
        let k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
      }
    } else if (name == 'name') {
      let inp = String.fromCharCode(event.keyCode);
      // Allow numbers, alpahbets, space, underscore
      if (/[a-zA-Z0-9-_ ]/.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    }
    else if (name == 'number') {
      let inp = String.fromCharCode(event.keyCode);
      // Allow numbers, alpahbets, space, underscore
      if (/[0-9]/.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    }
  }
  onDobChange(event: any) {
    const value = event.target.value;
    if (!value) {
      this.addUserForm.patchValue({ dob: null });
    } else {
      this.addUserForm.patchValue({ dob: value });
    }
    this.enableSaveButton();
  }


  enableSaveButton() {
    this.editButon = false;
  }

  removeSpace(event: any, name: any) {
    if (name == 'email' || name == 'phone') {
      if (event.code === "Space") {
        event.preventDefault()
      }
      if (event.code === "Backspace") {
        this.isEmailVerified = false;
      }
    }
    else {
      if (event.target.selectionStart === 0 && event.code === "Space") {
        event.preventDefault()
      }
    }
  }

  onlyAlphabets(event: any) {
    if (event.target.selectionStart === 0) {
      if ((/\d/g).test(event.key)) event.preventDefault();
    }
  }
  goBack() {
    this.location.back()
  }

  // Simple mapping of dial codes to CountryISO
  private dialCodeToISO: { [key: string]: CountryISO } = {
    '+93': CountryISO.Afghanistan,
    '+355': CountryISO.Albania,
    '+213': CountryISO.Algeria,
    '+1-684': CountryISO.AmericanSamoa,
    '+376': CountryISO.Andorra,
    '+244': CountryISO.Angola,
    '+1-264': CountryISO.Anguilla,
    '+1-268': CountryISO.AntiguaAndBarbuda,
    '+54': CountryISO.Argentina,
    '+374': CountryISO.Armenia,
    '+297': CountryISO.Aruba,
    '+61': CountryISO.Australia,
    '+43': CountryISO.Austria,
    '+994': CountryISO.Azerbaijan,
    '+1-242': CountryISO.Bahamas,
    '+973': CountryISO.Bahrain,
    '+880': CountryISO.Bangladesh,
    '+1-246': CountryISO.Barbados,
    '+375': CountryISO.Belarus,
    '+32': CountryISO.Belgium,
    '+501': CountryISO.Belize,
    '+229': CountryISO.Benin,
    '+1-441': CountryISO.Bermuda,
    '+975': CountryISO.Bhutan,
    '+591': CountryISO.Bolivia,
    '+387': CountryISO.BosniaAndHerzegovina,
    '+267': CountryISO.Botswana,
    '+55': CountryISO.Brazil,
    '+246': CountryISO.BritishIndianOceanTerritory,
    '+1-284': CountryISO.BritishVirginIslands,
    '+673': CountryISO.Brunei,
    '+359': CountryISO.Bulgaria,
    '+226': CountryISO.BurkinaFaso,
    '+257': CountryISO.Burundi,
    '+855': CountryISO.Cambodia,
    '+237': CountryISO.Cameroon,
    '+1': CountryISO.Canada,
    '+238': CountryISO.CapeVerde,
    '+599': CountryISO.CaribbeanNetherlands,
    '+1-345': CountryISO.CaymanIslands,
    '+236': CountryISO.CentralAfricanRepublic,
    '+235': CountryISO.Chad,
    '+56': CountryISO.Chile,
    '+86': CountryISO.China,
    '+57': CountryISO.Colombia,
    '+269': CountryISO.Comoros,
    '+243': CountryISO.CongoDRCJamhuriYaKidemokrasiaYaKongo,
    '+242': CountryISO.CongoRepublicCongoBrazzaville,
    '+682': CountryISO.CookIslands,
    '+506': CountryISO.CostaRica,
    '+225': CountryISO.CôteDIvoire,
    '+385': CountryISO.Croatia,
    '+53': CountryISO.Cuba,
    '+357': CountryISO.Cyprus,
    '+420': CountryISO.CzechRepublic,
    '+45': CountryISO.Denmark,
    '+253': CountryISO.Djibouti,
    '+1-767': CountryISO.Dominica,
    '+1-809': CountryISO.DominicanRepublic,
    '+593': CountryISO.Ecuador,
    '+20': CountryISO.Egypt,
    '+503': CountryISO.ElSalvador,
    '+240': CountryISO.EquatorialGuinea,
    '+291': CountryISO.Eritrea,
    '+372': CountryISO.Estonia,
    '+251': CountryISO.Ethiopia,
    '+500': CountryISO.FalklandIslands,
    '+298': CountryISO.FaroeIslands,
    '+679': CountryISO.Fiji,
    '+358': CountryISO.Finland,
    '+33': CountryISO.France,
    '+594': CountryISO.FrenchGuiana,
    '+689': CountryISO.FrenchPolynesia,
    '+241': CountryISO.Gabon,
    '+220': CountryISO.Gambia,
    '+995': CountryISO.Georgia,
    '+49': CountryISO.Germany,
    '+233': CountryISO.Ghana,
    '+350': CountryISO.Gibraltar,
    '+30': CountryISO.Greece,
    '+299': CountryISO.Greenland,
    '+1-473': CountryISO.Grenada,
    '+590': CountryISO.Guadeloupe,
    '+1-671': CountryISO.Guam,
    '+502': CountryISO.Guatemala,
    '+44': CountryISO.Guernsey,
    '+224': CountryISO.Guinea,
    '+245': CountryISO.GuineaBissau,
    '+592': CountryISO.Guyana,
    '+509': CountryISO.Haiti,
    '+504': CountryISO.Honduras,
    '+852': CountryISO.HongKong,
    '+36': CountryISO.Hungary,
    '+354': CountryISO.Iceland,
    '+91': CountryISO.India,
    '+62': CountryISO.Indonesia,
    '+98': CountryISO.Iran,
    '+964': CountryISO.Iraq,
    '+353': CountryISO.Ireland,
    '+972': CountryISO.Israel,
    '+39': CountryISO.Italy,
    '+1-876': CountryISO.Jamaica,
    '+81': CountryISO.Japan,
    '+962': CountryISO.Jordan,
    '+7': CountryISO.Kazakhstan,
    '+254': CountryISO.Kenya,
    '+686': CountryISO.Kiribati,
    '+383': CountryISO.Kosovo,
    '+965': CountryISO.Kuwait,
    '+996': CountryISO.Kyrgyzstan,
    '+856': CountryISO.Laos,
    '+371': CountryISO.Latvia,
    '+961': CountryISO.Lebanon,
    '+266': CountryISO.Lesotho,
    '+231': CountryISO.Liberia,
    '+218': CountryISO.Libya,
    '+423': CountryISO.Liechtenstein,
    '+370': CountryISO.Lithuania,
    '+352': CountryISO.Luxembourg,
    '+853': CountryISO.Macau,
    '+389': CountryISO.Macedonia,
    '+261': CountryISO.Madagascar,
    '+265': CountryISO.Malawi,
    '+60': CountryISO.Malaysia,
    '+960': CountryISO.Maldives,
    '+223': CountryISO.Mali,
    '+356': CountryISO.Malta,
    '+692': CountryISO.MarshallIslands,
    '+596': CountryISO.Martinique,
    '+222': CountryISO.Mauritania,
    '+230': CountryISO.Mauritius,
    '+262': CountryISO.Mayotte,
    '+52': CountryISO.Mexico,
    '+691': CountryISO.Micronesia,
    '+373': CountryISO.Moldova,
    '+377': CountryISO.Monaco,
    '+976': CountryISO.Mongolia,
    '+382': CountryISO.Montenegro,
    '+1-664': CountryISO.Montserrat,
    '+212': CountryISO.Morocco,
    '+258': CountryISO.Mozambique,
    '+95': CountryISO.Myanmar,
    '+264': CountryISO.Namibia,
    '+674': CountryISO.Nauru,
    '+977': CountryISO.Nepal,
    '+31': CountryISO.Netherlands,
    '+687': CountryISO.NewCaledonia,
    '+64': CountryISO.NewZealand,
    '+505': CountryISO.Nicaragua,
    '+227': CountryISO.Niger,
    '+234': CountryISO.Nigeria,
    '+683': CountryISO.Niue,
    '+672': CountryISO.NorfolkIsland,
    '+850': CountryISO.NorthKorea,
    '+1-670': CountryISO.NorthernMarianaIslands,
    '+47': CountryISO.Norway,
    '+968': CountryISO.Oman,
    '+92': CountryISO.Pakistan,
    '+680': CountryISO.Palau,
    '+970': CountryISO.Palestine,
    '+507': CountryISO.Panama,
    '+675': CountryISO.PapuaNewGuinea,
    '+595': CountryISO.Paraguay,
    '+51': CountryISO.Peru,
    '+63': CountryISO.Philippines,
    '+48': CountryISO.Poland,
    '+351': CountryISO.Portugal,
    '+1-787': CountryISO.PuertoRico,
    '+974': CountryISO.Qatar,
    '+40': CountryISO.Romania,
    '+250': CountryISO.Rwanda,
    '+290': CountryISO.SaintHelena,
    '+1-869': CountryISO.SaintKittsAndNevis,
    '+1-758': CountryISO.SaintLucia,
    '+508': CountryISO.SaintPierreAndMiquelon,
    '+1-784': CountryISO.SaintVincentAndTheGrenadines,
    '+685': CountryISO.Samoa,
    '+378': CountryISO.SanMarino,
    '+239': CountryISO.SãoToméAndPríncipe,
    '+966': CountryISO.SaudiArabia,
    '+221': CountryISO.Senegal,
    '+381': CountryISO.Serbia,
    '+248': CountryISO.Seychelles,
    '+232': CountryISO.SierraLeone,
    '+65': CountryISO.Singapore,
    '+1-721': CountryISO.SintMaarten,
    '+421': CountryISO.Slovakia,
    '+386': CountryISO.Slovenia,
    '+677': CountryISO.SolomonIslands,
    '+252': CountryISO.Somalia,
    '+27': CountryISO.SouthAfrica,
    '+82': CountryISO.SouthKorea,
    '+211': CountryISO.SouthSudan,
    '+34': CountryISO.Spain,
    '+94': CountryISO.SriLanka,
    '+249': CountryISO.Sudan,
    '+597': CountryISO.Suriname,
    '+268': CountryISO.Swaziland,
    '+46': CountryISO.Sweden,
    '+41': CountryISO.Switzerland,
    '+963': CountryISO.Syria,
    '+886': CountryISO.Taiwan,
    '+992': CountryISO.Tajikistan,
    '+255': CountryISO.Tanzania,
    '+66': CountryISO.Thailand,
    '+670': CountryISO.TimorLeste,
    '+228': CountryISO.Togo,
    '+690': CountryISO.Tokelau,
    '+676': CountryISO.Tonga,
    '+1-868': CountryISO.TrinidadAndTobago,
    '+216': CountryISO.Tunisia,
    '+90': CountryISO.Turkey,
    '+993': CountryISO.Turkmenistan,
    '+1-649': CountryISO.TurksAndCaicosIslands,
    '+688': CountryISO.Tuvalu,
    '+1-340': CountryISO.USVirginIslands,
    '+256': CountryISO.Uganda,
    '+380': CountryISO.Ukraine,
    '+971': CountryISO.UnitedArabEmirates,
    '+598': CountryISO.Uruguay,
    '+998': CountryISO.Uzbekistan,
    '+678': CountryISO.Vanuatu,
    '+58': CountryISO.Venezuela,
    '+84': CountryISO.Vietnam,
    '+681': CountryISO.WallisAndFutuna,
    '+967': CountryISO.Yemen,
    '+260': CountryISO.Zambia,
    '+263': CountryISO.Zimbabwe,
  };


  ngOnInit(): void {
    this.editButon = true;
    let input: any;
    const initialValue = this.addUserForm.controls['phone'].value?.number || '';
    this.initialPhoneNumber = initialValue;
    this.isEmailVerified = false;
    this.getAllData();
    this.emailValue = this.addUserForm.controls['email'].value;
    this.initialName = this.addUserForm.controls['name'].value;
    this.intialPhoneNumber = this.addUserForm.controls['phone'].value?.number || '';
    // Subscribe to changes in the name field
    if (this.isupdateUser) {
      this.addUserForm.controls['name'].valueChanges.subscribe(value => {
        this.checkForUpdateUserName(value);
      });
      this.addUserForm.controls['phone'].valueChanges.subscribe(value => {
        this.mobileValueChange(value);
      });

      this.addUserForm.controls['email'].valueChanges.subscribe(value => {
        this.checkForUpdateEmail(value);
      });
      this.addUserForm.valueChanges.subscribe(formValue => {
        let currentUser = localStorage.getItem('currentUser');
        if (currentUser) {
          this.loggedInUser = JSON.parse(currentUser);
        }
        const role = this.addUserForm.get('role')?.value;
        const parentRole = this.loggedInUser?.roleType;
        console.log(`Form changed. Checking isHierarchy: parent=${parentRole}, selected=${role}`);
        this.isHierarchy = this.shouldDisablePhone(parentRole, role);

        const phoneControl = this.addUserForm.get('phone');
        if (phoneControl) {
          if (this.isHierarchy) {
            phoneControl.disable({ emitEvent: false });
          } else {
            phoneControl.enable({ emitEvent: false });
          }
        }
      });

    }
  }

  shouldDisablePhone(parentRole: string, role: string): boolean {

    const pRole = parentRole?.toUpperCase();
    const rRole = role?.toUpperCase();

    if (pRole === 'SUPER_ADMIN') {
      return ['ADMIN', 'MEMBERS', 'CHILD'].includes(rRole);
    }

    if (pRole === 'ADMIN') {
      return ['MEMBERS', 'CHILD'].includes(rRole);
    }

    if (pRole === 'MEMBERS') {
      return rRole === 'CHILD';
    }

    return false;
  }


  checkForUpdateUserName(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const name = inputElement.value;
    const tempName = this.addUserForm.controls['name'].value.string || '';
    if (this.initialName == name) {
      this.editButon = true;
    } else {
      this.editButon = false;
    }
  }

  checkForUpdateEmail(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const name = inputElement.value;
    const tempName = this.addUserForm.controls['name'].value.string || '';
    if (this.initialName == name) {
      this.editButon = true;
    } else {
      this.editButon = false;
    }
  }


  emailOTP() {
    this.forgotPasswordErrorMessage = '';
    try {
      this.emailErrorMessage = null;
      clearInterval(this.timer);

      this.timeOver = true;
      let data = {
        userName: this.addUserForm.controls['email'].value,
        otpType: CommonEnums.SIGNUP
      };
      this._service
        .postService(this._service.API_URL.emailGenerateOtp, data)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.isEmailOTPSent = true;
            this.mobileOrEmailOTP = 'EMAIL';
            this.startTimerForFiveMinute(3);
            this.emailResponseOTP = response.data;
            setTimeout(() => {
              this.ngOtpInputRef.setValue(null);
            }, 0);
            $("#OtpPopup").modal("show");
          } else {
            this.isEmailOTPSent = false;
            this.emailErrorMessage = response.status.message;
          }
          if (response && response.status.code === 400) {
            this._toastr.error('', response.status.message)
          }
        });
    } catch (e) { }
  }
  //  Start timer for Email Verification
  startTimerForFiveMinute(minute: number) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    this.timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.durationMinutes = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;


      if (seconds == 0) {
        this.timeOver = false;
        clearInterval(this.timer);
      }
    }, 1000);
  }

  verifyAgain(d: any) {
    this.isVerified = false;
    this.isEmailOTPSent = false;
    this.isEmailVerified = false;
    this.otpValue = null;
    this.emailResponseOTP = null;
    this.timeOver = false;
    this.isSentOTP = false;
    this.forgotPasswordErrorMessage = '';
    if (d == 'role')
      this.addUserForm.reset();
  }

  //fetching required data at ngOnInit
  getAllData(): void {
    $("#target").val($("#target option:first").val());
    this.screenWidth = window.screen.width;
    this.screenHeight = window.screen.height;
    scrollTo(0, 0);
    let currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      this.loggedInUser = JSON.parse(currentUser);
      console.log('loggedInUser object:', this.loggedInUser);
    }

    let selectedLangStringValue = localStorage.getItem('selectedLang');
    if (selectedLangStringValue) {
      this.selectedLanguage = selectedLangStringValue;
      this._translate.use(this.selectedLanguage);
    }

    if (this.isupdateUser || this.isupdateProfile) {
      this.addUserForm = this._formBuilder.group({
        name: [this.updateUser?.name, [Validators.required]],
        role: [this.updateUser.roleType, [Validators.required]],
        email: [this.updateUser?.email, [Validators.required, Validators.email, Validators.pattern("^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,3}(?:\\.[A-Za-z]{2,3})?)$")]],
        gender: [this.updateUser?.genderType],
        dialCode: [this.updateUser.countryCode],
        phone: [this.updateUser.mobileNo],
        dob: [this.datePipe.transform(this.updateUser.dateOfBirth, "yyyy-MM-dd")],
      });
      this.setInitialCountry(this.updateUser.countryCode)
      if (!(this.isupdateUser && this.updateUser.assignedUserStatus == "ASSIGNED_USER_STATUS_PENDING")) {
        this.addUserForm.get('role')?.disable();
        this.addUserForm.get('email')?.disable();
      }
      if (!(this.isupdateUser && this.updateUser.assignedUserStatus != "ASSIGNED_USER_STATUS_PENDING")) {
        this.addUserForm.get('role')?.disable();
      }
      this.isVerified = this.updateUser.mobileNoVerified;
    }
    if (!(this.isupdateUser || this.isupdateProfile)) {
      this.addUserForm = this._formBuilder.group({
        name: ['', [Validators.required]],
        role: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email, Validators.pattern("^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,3}(?:\\.[A-Za-z]{2,3})?)$")]],
        gender: [''],
        phone: [''],
        dob: [''],
      });
    }
    this.language = localStorage.getItem('selectedLang');
    if (!this.language || this.language == 'en' || this.language == '') {
      this.modalForEng = false;
    } else {
      this.modalForEng = true;
    }
  }

  //get common enums
  public get CommonEnum(): typeof CommonEnums {
    return CommonEnums;
  }

  // To get OTP for the Add User
  // getting otp value

  onOtpChange(event: any) {
    this.emailErrorMessage = null;
    this.otpValue = event;
  }

  config = {
    allowNumbersOnly: true,
    length: 4,
  };


  verifyOtp() {
    if (this.otpValue?.length == 4) {
      this.submitOTPDto.otpChar = this.emailResponseOTP;
      this.submitOTPDto.otpType = CommonEnums.SIGNUP;
      this.submitOTPDto.otpNo = this.otpValue
      this._service
        .postService(
          this._service.API_URL.signupOtpVerification,
          this.submitOTPDto
        )
        .subscribe((response: any) => {
          if (response.status.code === 200) {
            this.timeOver = true;
            this.isVerified = true;
          } else {
            this.isVerified = false;
            this.forgotPasswordErrorMessage = response.status.message;
          }
        });
    }
  }
  //Add User Function
  AddUser(event: MouseEvent) {
    this.isLoading = true;
    try {
      this.myaccountDto.name = this.addUserForm.controls['name'].value;
      this.myaccountDto.email = this.addUserForm.controls['email'].value;
      this.myaccountDto.mobileNo = this.addUserForm.controls['phone'].value?.number;
      this.myaccountDto.countryCode = this.addUserForm.controls['phone'].value?.dialCode;
      const genderValue = this.addUserForm.controls['gender'].value;
      this.myaccountDto.gender = genderValue ? genderValue.toUpperCase() : null;
      this.myaccountDto.dateOfBirth = this.addUserForm.controls['dob'].value;
      this.myaccountDto.role = this.addUserForm.controls['role'].value;
      this.myaccountDto.isMobileNoVerified = this.isVerified;

      (event.target as HTMLButtonElement).disabled = true;
      if (this.myaccountDto.email) {
        this.emailSentUserName = this.myaccountDto.email;
        this.addUserErrorMessage = null;
        this._service.postService(this._service.API_URL.addUser, this.myaccountDto).subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            if (this.myaccountDto.role == CommonEnums.CHILD) {

              this.showAddUserPopup = 'CHILD';
            } else {
              this.showAddUserPopup = 'YES';
            }
            $('#InvitePopUp').modal('show');
          } else if (response && response.status.code === 400) {
            this.isLoading = false;
            this._toastr.error('', response.status.message);

            (event.target as HTMLButtonElement).disabled = false;
          }
        })
      }
    } catch (error) {
      this.isLoading = false;

    }
  }

  //UpdateUser Logic
  updateUserDetails(event: MouseEvent) {
    this.isLoading = true;
    try {
      this.isSubmitted = true;
      this.myaccountDto.id = this.updateUser.id;
      this.myaccountDto.name = this.addUserForm.controls['name'].value;
      const genderValue = this.addUserForm.controls['gender'].value;
      this.myaccountDto.gender = genderValue ? genderValue.toUpperCase() : null;
      this.myaccountDto.dateOfBirth = this.addUserForm.controls['dob'].value;
      this.myaccountDto.mobileNo = this.addUserForm.controls['phone'].value?.number;
      this.myaccountDto.countryCode = this.addUserForm.controls['phone'].value?.dialCode;
      if (this.isupdateUser && this.updateUser.assignedUserStatus == "ASSIGNED_USER_STATUS_PENDING") {
        this.myaccountDto.role = this.addUserForm.controls['role'].value;
        this.myaccountDto.email = this.addUserForm.controls['email'].value;
      }

      this.myaccountDto.assignedUserStatus = this.updateUser.assignedUserStatus;
      this.myaccountDto.isMobileNoVerified = this.isVerified;
      this._service.putService(this._service.API_URL.saveOrUpdateUserAccount, this.myaccountDto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this._toastr.success('', response.status.message);
          let currentUser = localStorage.getItem('currentUser');
          if (currentUser) {
            this.loggedInUser = JSON.parse(currentUser);
            this.loggedInUser.avatarUrl = this.myaccountDto.avatarUrl;
            this.loggedInUser.name = this.myaccountDto.name;
            localStorage.setItem('currentUser', JSON.stringify(this.loggedInUser));
          }
          this.removeChildEvent.emit();
          this.isLoading = false;

        } else {
          this._toastr.error('', response.status.message);
          this.isLoading = false;
        }
      })
    } catch (error) {
      this.isLoading = false;
    }

  }
  getObjecKey: any;
  onSubmit() {
    this.isLoading = true;
    try {
      this.isSubmitted = true;
      this.myaccountDto.id = this.updateUser.id;
      this.myaccountDto.name = this.addUserForm.controls['name'].value;
      const genderValue = this.addUserForm.controls['gender'].value;
      this.myaccountDto.gender = genderValue ? genderValue.toUpperCase() : null;

      let dobValue = this.addUserForm.controls['dob'].value;

      if (!dobValue) {
        this.myaccountDto.dateOfBirth = null;
      } else {
        this.myaccountDto.dateOfBirth = dobValue;
      }

      this.myaccountDto.mobileNo = this.addUserForm.controls['phone'].value?.number;
      this.myaccountDto.countryCode = this.addUserForm.controls['phone'].value?.dialCode;
      this.myaccountDto.avatarUrl = this.getObjecKey;
      this.myaccountDto.isMobileNoVerified = this.isVerified;

      this._service.putService(this._service.API_URL.saveOrUpdateMyAccount, this.myaccountDto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this._toastr.success('', response.status.message);
          let currentUser = localStorage.getItem('currentUser');
          if (currentUser) {
            this.loggedInUser = JSON.parse(currentUser);
            this.loggedInUser.avatarUrl = this.myaccountDto.avatarUrl;
            this.loggedInUser.name = this.myaccountDto.name;
            localStorage.setItem('currentUser', JSON.stringify(this.loggedInUser));
          }
          this.removeChildEvent.emit();
          this.isLoading = false;

        } else {
          this._toastr.error('', response.status.message);
          this.isLoading = false;
        }
      })
    } catch (error) {
      this.isLoading = false;
    }

  }



  //  To Add the User Logic has been implemented here
  onAddUser(event: MouseEvent) {

    if (!(this.isupdateUser || this.isupdateProfile)) {
      this.AddUser(event);
    }
    if (this.isupdateProfile) {
      this.onSubmit();
    }
    else {
      this.updateUserDetails(event);
    }


  }
  resetvalues() {
    this.verifyEmail = false;
    this.verifyMobileNumber = false;
    this.isSentOTP = false;
    this.timeOver = true;
    this.durationMinutes = `01`
  }

  // Checking on Mobie validation on Focus Out and Verifying
  mobileNoWrong: boolean = false;
  onFocusOutMobile(event: any) {
    const inputElement = event.target as HTMLInputElement;
    const dialCodeIs = this.addUserForm.controls['phone'].value.dialCode;
    this.dialCodeNotInd = dialCodeIs;
    if (this.addUserForm.controls['phone'].value.number?.length < 8) {
      this.mobileNoWrong = true;
    } else {
      this.mobileNoWrong = false;
    }
    this.otpPhoneError = null;
  }

  //mobile otp verification
  otpPhoneError: any
  otpError: any
  verify(type: any) {
    this.isLoading = true
    this.otpPhoneError = null;
    let data;
    this.timeOver = true;
    clearInterval(this.timer);
    if (type == 'Send') {
      data = {
        countryCode: this.addUserForm.controls['phone'].value?.dialCode,
        userName: this.addUserForm.controls['phone'].value?.number,
        otpType: CommonEnums.MOBILE_VERIFICATION,
      }
    } else {
      this.otpPhoneError = null;
      this.ngOtpInputRef.setValue(null);
      //this.myaccountDto.MobileNoVerified = false;
      data = {
        countryCode: this.addUserForm.controls['phone'].value?.dialCode,
        userName: this.addUserForm.controls['phone'].value?.number,
        otpType: CommonEnums.MOBILE_VERIFICATION,
      }
    }
    try {
      this._service.postService(this._service.API_URL.generateOTP, data).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          if (response.status.msgCode == "MOBILE_VERIFICATION") {
            this._toastr.success('', response.status.message);
            this.isLoading = false;
            this.isEmailVerified = true;
            this.isOtpVerification = true;
            this.mobileOrEmailOTP = 'MOBILE';
            this.enableMobileVerificationIcon = true;
            this.verifyMobileNumber = true;
            this.isVerified = true;
            this.mobileInput = false;

          } else {
            this.startTimerForFiveMinute(3);
            this._toastr.success('', response.status.message);
            this.emailResponseOTP = response.data;
            this.verifyEmail = true;
            this.verifyMobileNumber = true;
            this.isSentOTP = true;
            this.mobileOrEmailOTP = 'MOBILE';
            this.isLoading = false;
            this.isVerified = false;
            $("#OtpPopup").modal("show");
          }
        } else
          if (response.data == null || response.status.code === 400) {
            this.otpPhoneError = response.status.message;
            this.isLoading = false
          }
          else {
            this._toastr.error('', response.status.message);
            this.verifyEmail = false;
            this.verifyMobileNumber = false;
            this.isSentOTP = false;
            this.isLoading = false;
          }
      })
    }
    catch (e) { }

  }

  submitOTP() {
    this.otpError = null;
    this.otpPhoneError = null;
    try {
      if (this.mobileOrEmailOTP == 'EMAIL') {
        this.emailOrMobileVerificationDto.otpNo = this.otpValue;
        this.emailOrMobileVerificationDto.otpType = CommonEnums.SIGNUP;
        this.emailOrMobileVerificationDto.otpChar = this.emailResponseOTP;
      } else {
        this.emailOrMobileVerificationDto.otpNo = this.otpValue;
        this.emailOrMobileVerificationDto.otpType = CommonEnums.MOBILE_VERIFICATION;
        this.emailOrMobileVerificationDto.otpChar = this.emailResponseOTP;
        //this.emailOrMobileVerificationDto.userId = this.updateUser.id;
        //this.emailOrMobileVerificationDto.assignedUserStatus = this.updateUser.assignedUserStatus;
      }
      if (this.otpValue?.length === 4) {
        if (this.isupdateProfile) {
          if (this.otpValue?.length === 4) {
            this._service.postService(this._service.API_URL.otpVerification, this.emailOrMobileVerificationDto).subscribe((response) => {
              if (response && response.status.code === 200) {
                // this.isEmailVerified = true; 
                this.isEmailOTPSent = false;
                this.editButon = false;
                this.isOtpVerification = true;
                this.verifyEmail = false;
                this.enableMobileVerificationIcon = true;
                this.verifyMobileNumber = false;
                this.otpError = null;
                this.otpPhoneError = null;
                this.mobileInput = false;
                this._toastr.success('', response.status.message)
              } else if (response.data == null || response.status.code === 400) {
                this.isEmailOTPSent = false;
                this.editButon = true;
                this.isEmailVerified = false;
                this.otpError = response.status.message;
              }
              else {
                this.isOtpVerification = true;
                this.verifyEmail = false;
                this.enableMobileVerificationIcon = true;
                this.verifyMobileNumber = false;
                this.timeOver = false;
                this.mobileInput = false;
                this.getMyAccountData();
                this.otpError = response.status.meassage;

              }
            })
          }
        }
        this._service.postService(this._service.API_URL.addUserOtpVerification, this.emailOrMobileVerificationDto).subscribe((response) => {
          if (response && response.status.code === 200) {
            this.editButon = false;
            this.isOtpVerification = true;
            this.verifyEmail = false;
            this.enableMobileVerificationIcon = true;
            this.verifyMobileNumber = false;
            this.timeOver = false;
            this.otpError = null;
            this.otpPhoneError = null;
            this.mobileInput = false;
            if (this.mobileOrEmailOTP == 'EMAIL') {
              this.isEmailVerified = true;
            } else {
              this.isVerified = true;
            }
            $("#OtpPopup").modal("hide");
            this.ngOtpInputRef.setValue(null);
            this._toastr.success('', response.status.message)
            this.isLoading = false;
          } else if (response.data == null || response.status.code === 400) {
            this.isVerified = false;
            this.isEmailVerified = false;
            this.otpError = response.status.message;
            this.isLoading = false;
          }
          else {
            this.isOtpVerification = true;
            this.verifyEmail = false;
            this.enableMobileVerificationIcon = true;
            this.verifyMobileNumber = false;
            this.timeOver = false;
            this.mobileInput = false;
            this.otpError = response.status.meassage;
            this.isLoading = false;
            this.isVerified = false;
          }
        })

      }
    }
    catch (e) {
    }
  }

  avatarImage: any;
  getMyAccountData() {
    this.isLoading = true
    try {
      this._service.getService(this._service.API_URL.getMyAccountData).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.myAccountData = response.data;
          setTimeout(() => {
            this.avatarImage = response.data.avatarUrl;
            this.isLoading = false
          }, 1000);
          this.getObjecKey = response.data.avatarUrl;
          this.addUserForm.patchValue(response.data)
          if (this.isupdateProfile) {
            this.addUserForm.controls['gender'].setValue(response.data.genderType);
          }

          if (this.getObjecKey) {
          }
        }
      })
    } catch (error) {

    }
  }
  openManageUser() {
    if (this.isupdateUser || this.isupdateProfile) {
      this.removeChildEvent.emit();
    }
    else {
      this._router.navigate(['home/manage-user']);
      $('#InvitePopUp').modal('hide');
    }
  }
  backToManageUser() {
    this, this._router.navigate(['home/manage-user']);
    $('#InvitePopUp').modal('hide');
  }

  mobileValueChange(event: Event) {
    this.onPhoneChange(event);
    const inputElement = event.target as HTMLInputElement;
    const phoneNumber = inputElement.value;
    const tempPhoneNumber = this.addUserForm.controls['phone'].value?.number || '';
    if (phoneNumber === this.initialPhoneNumber && phoneNumber != '' && phoneNumber != null && phoneNumber != undefined) {
      this.isVerified = true;
      this.editButon = false;
    } else if (this.addUserForm.controls['phone'].value?.dialCode != 91 || this.addUserForm.controls['phone'].value?.dialCode != +91) {
      this.isVerified = true;
      this.editButon = false;
    }
    else {
      this.isVerified = false;
      this.dialCodeNotInd = 91;
      this.editButon = true;
    }
  }

  onPhoneChange(event: any) {
    this.selectedCountryCode = event.dialCode
    if (this.selectedCountryCode != 91 || this.selectedCountryCode != +91) {
      this.dialCodeNotInd = this.selectedCountryCode;
      this.isVerified = true;
      this.editButon = false;
    } else {
      this.dialCodeNotInd = 91;
      if (this.updateUser != null && this.updateUser.countryCode != +91) {
        this.isVerified = false;
      }
      this.isVerified = false;
      this.editButon = true;
    }
  }





  closeModal() {
    this.ngOtpInputRef.setValue(null);
    $("#OtpPopup").modal("hide");
    if (this.mobileOrEmailOTP == 'EMAIL') {
      this.isEmailOTPSent = false;
      this.isEmailVerified = false;
    }
    else {
      this.verifyMobileNumber = false;
      this.isSentOTP = false;
      this.isVerified = false;
    }

  }
  // these functions are to make sure any changes while adding the fields to reflect the same in validation mode 
  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  emailChangeValue(newValue: string) {
    if (this.validateEmail(newValue)) {
      if (newValue !== this.storedEmail) {
        this.isEmailVerified = false;
      } else {
        this.isEmailVerified = true;
      }
    }
  }

  private setInitialCountry(dialCode: string) {
    console.log("value DC" + dialCode);
    const countryISO = this.dialCodeToISO[dialCode];

    if (countryISO) {
      this.selectedCountryISO = countryISO;
    }

    this.currentFlagUrl = this.getFlagUrl(this.selectedCountryISO);
  }

  private getFlagUrl(isoCode: CountryISO): string {
    return `https://flagcdn.com/${isoCode.toLowerCase()}.svg`;
  }

  onCountryChange(event: any) {
    this.selectedCountryISO = event.iso2 as CountryISO;
    this.currentFlagUrl = this.getFlagUrl(this.selectedCountryISO);
  }

}